import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import * as Rb from "react-bootstrap";
import {
  saveData,
  saveDataToDocsAndStorage,
} from "../../../core/Firebase/services/FirebaseService";
import { CustomAlert, customToast } from "../../../core/js/backoffice";
import {
  dirInput,
  mapClassNameToLangue,
  mapLanguesToFlag,
  mapOriginalLanguesToName,
  mapTranslate,
} from "../../../core/localization/map_langues";
import {
  blockUIAction,
  closeModalAdd,
} from "../../../core/Redux/features/user";
import { SousThemeModel } from "../../../core/models/Sous-Theme-Model";
import { useDocs, useWhereDocs } from "../../../core/Firebase/FirebaseHooks";
import { db } from "../../../core/Firebase/firebase";
import { motion } from "framer-motion";
import Select from "react-select";
import ArabicInput from "../../../partials/FrequentlyUsed/ArabicInput";
import { selectedBase } from "../../../core/Firebase/firebase";

export const ModalBodySousThemes = (props) => {
  const dispatch = useDispatch();
  const themeRef = useRef();
  const degRef = useRef();
  const descriptionRef = useRef();
  const [validated, setValidated] = useState(false);
  const [id, setId] = useState();
  const [theme, setTheme] = useState();
  const [valueTheme, setValueTheme] = useState(null);
  const [isUpdate] = useState(props.isAdd === false);
  const [itemToUpdate] = useState(props.itemToUpdate);

  const [langues, setLangues] = useState([]);
  const [degMap, setDegMap] = useState({});
  const [descMap, setDescMap] = useState({});
  const [keywordMap, setKeywordMap] = useState({});
  const [selectedLng, setSelectedLng] = useState();
  const [showArabicInput, setShowArabicInput] = useState(false);
  const [showArabicInput1, setShowArabicInput1] = useState(false);
  const [showArabicInput2, setShowArabicInput2] = useState(false);
  const [layoutName, setLayoutName] = useState("default");
  const [file, setFile] = useState();
  const [fileUrl, setFileUrl] = useState();
  const [isErase, setIsErase] = useState(false);
  const [ordreMap, setOrdre] = useState({});
  const { data } = useWhereDocs({
    db: db,
    collectionName: "preferences",
    whereToLookInTheCollection: "isPrefs",
    whereToLookValue: true,
  });
  const { data: dataLng, dataLoading } = useDocs({
    db: db,
    collectionName:
      "preferences_" + selectedBase + "/" + data[0]?.id + "/langues",
    whereToOrderBy: "id",
  });
  const { data: tabThemes, dataThemeLoading } = useDocs({
    db: db,
    converterName: "themes",
    sort: "desc",
  });

  useEffect(() => {
    dispatch(blockUIAction(dataLoading && dataThemeLoading));
    if (isUpdate === true && itemToUpdate) {
      setId(itemToUpdate.id);
      setTheme(itemToUpdate["themeId"]);
      let y = tabThemes
        .filter((i) => i["id"] === itemToUpdate["themeId"])
        .map((item) => {
          return { value: item["id"], label: item["designation"] };
        });
      setValueTheme(y[0]);
      setDegMap(itemToUpdate.designationMap);
      setDescMap(itemToUpdate.descriptionMap);
      setOrdre(itemToUpdate.ordreMap);
      setKeywordMap(itemToUpdate.keywords);
      setFileUrl(itemToUpdate.fileUrl);
    }
  }, [isUpdate, itemToUpdate, dataLoading, dataThemeLoading]);

  useEffect(() => {
    if (dataLng.length > 0) {
      let aaa = Object.keys(dataLng[0].value ?? {});
      if (isUpdate !== true) {
        aaa.forEach((key) => {
          //degMap[key] = "";
          descMap[key] = "";
          ordreMap[key] = "";
          //setDegMap(degMap);
          setDescMap(descMap);
          setOrdre(ordreMap);
        });
      }
      let n = aaa.filter((u) => u.indexOf("fr_FR") !== -1);
      if (n.length === 1) {
        setSelectedLng(n[0]);
      } else {
        setSelectedLng(aaa[0]);
      }
      setLangues(aaa);
    }
  }, [dataLng, isUpdate]);

  const closeKeyBoardArabic = () => {
    setShowArabicInput(false);
  };
  const closeKeyBoardArabic1 = () => {
    setShowArabicInput1(false);
  };

  const closeKeyBoardArabic2 = () => {
    setShowArabicInput2(false);
  };

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === true) {
      if (!theme || theme === "default") {
        customToast({ message: "Renseignez le champ théme", type: "error" });
      } else {
        if (
          Object.keys(degMap).length < langues.length &&
          Object.values(degMap).every((u) => u !== "")
        ) {
          customToast({
            message:
              "Désignation Obligatoire pour les " + langues.length + " langues",
            type: "error",
          });
        } else {
          //console.log(sousTheme);
          let tabKeywords = Object.fromEntries(Object.entries(keywordMap));

          Object.keys(tabKeywords).forEach((key) => {
            tabKeywords[key] = convertStringToMap({ value: tabKeywords[key] });
          });

          let sousTheme = new SousThemeModel({
            id: id,
            description: descMap,
            designation: degMap,
            theme: theme,
            // keywords: tabKeywords,
            eraseImg: isErase,
            ordre: ordreMap,
          });

          Object.keys(tabKeywords).forEach((key) => {
            if (degMap[key] && !tabKeywords[key].includes(degMap[key].trim())) {
              tabKeywords[key].push(degMap[key]);
            }
  
            if (descMap[key] && !tabKeywords[key].includes(descMap[key].trim())) {
              tabKeywords[key].push(descMap[key]);
            }
          });

          sousTheme = { ...sousTheme, ["keywords"]: tabKeywords };

          let sousThemeModel = new SousThemeModel(sousTheme)

          //saveData({dataType: 'sous_themes', dataToSave: sousTheme});
          saveDataToDocsAndStorage({
            dataType: "sous_themes",
            jsonData: sousThemeModel,
            file: file,
          });
        }
      }
    }
    setValidated(true);

    function convertStringToMap({ value }) {
      let keywords = String(value);
      let tabKeywords = [];
      let tmpKeywords = keywords?.trim().split(";");
      tabKeywords = tmpKeywords.map((u) => {
        return u.trim();
      });
      tabKeywords = tabKeywords.filter((u) => u.trim().length > 0);
      return tabKeywords;
    }
  };
  const handleFileChange = (event) => {
    //console.log(event.target.files);
    let filesTab = event.target.files;
    if (filesTab.length > 0) {
      setFile(filesTab[0]);
      setIsErase(false);
      setFileUrl(URL.createObjectURL(event.target.files[0]));
    }
  };
  const eraseImage = () => {
    if (isUpdate === true) {
      if (itemToUpdate.fileUrl) {
        setIsErase(true);
      }
    }
    setFileUrl(undefined);
  };
  return (
    <div className="container-fluid">
      <div className="d-flex mt-20">
        <div className="c-flexed m-auto">
          <label className="cursor-pointer">
            <input type="file" accept="image/*" onChange={handleFileChange} />
            {!fileUrl && (
              <div className="doted-circle cursor-pointer">
                <img alt="" src="/assets/images/ico/upload-pub.svg" />
                <span className="text-indic text-center">
                  Ajouter
                  <br />
                  votre image ici
                </span>
              </div>
            )}

            {fileUrl && (
              <span className="avatar avatar-online d-flex box-shadow-1 hpx-130 wdpx-130">
                <img alt="" className="m-auto hpx-130 wdpx-130" src={fileUrl} />
              </span>
            )}
          </label>
          {fileUrl && (
            <div className="d-flex">
              <button
                style={{ padding: "5px 10px" }}
                onClick={eraseImage}
                className="btn btn-danger m-auto"
              >
                <i className="fa fa-trash" />
              </button>
            </div>
          )}
        </div>
      </div>

      <Rb.Form
        className="mt-20"
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
      >
        <Rb.Row>
          <Rb.Col xs={12}>
            <Rb.Form.Group className="form-group" controlId="theme">
              <Rb.FormLabel className="textClassInit">
                Thème <span className="text-danger">*</span>
              </Rb.FormLabel>
              <Select
                ref={themeRef}
                placeholder="Thème"
                isClearable={true}
                value={valueTheme}
                onChange={(e) => {
                  if (e?.value !== valueTheme?.value) {
                    setTheme(e?.value);
                    setValueTheme(e);
                  }
                }}
                options={tabThemes.map((item) => {
                  return { value: item["id"], label: item["designation"] };
                })}
              />
            </Rb.Form.Group>
          </Rb.Col>

          <div
            className="w-100 mb-20 mt-10"
            style={{ borderTop: "1px solid black" }}
          ></div>
          <Rb.Stack className="m-auto" gap={4} direction="horizontal">
            {langues
              .sort()
              .reverse()
              .map((item, index) => {
                return (
                  <div key={index}>
                    <motion.button
                      onClick={() => {
                        setSelectedLng(item);
                      }}
                      style={{
                        color: selectedLng === item ? "white" : "#337F77",
                        background:
                          selectedLng === item
                            ? "#337F77"
                            : "rgba(51, 127, 119, 0.3)",
                      }}
                      type="button"
                      className="btn btn-lng"
                      whileHover={{
                        scale: 1.1,
                        transition: { duration: 0.5 },
                      }}
                      whileTap={{ scale: 0.9 }}
                    >
                      {mapOriginalLanguesToName[item]}{" "}
                      <i className={mapLanguesToFlag[item]}></i>
                    </motion.button>
                  </div>
                );
              })}
          </Rb.Stack>
          <div className="w-100 mb-20 mt-10"></div>

          {selectedLng && (
            <Rb.Col xs={6}>
              <Rb.Form.Group className="form-group" controlId="titre">
                <Rb.Form.Label
                  style={{
                    display: "flex",
                    flexDirection:
                      mapClassNameToLangue["flexDirection"][selectedLng],
                  }}
                  className={
                    "textClassInit column-gap-10 " +
                    mapClassNameToLangue["float"][selectedLng]
                  }
                >
                  {mapTranslate["nomTheme"][selectedLng]}
                  <span className="text-danger">*</span>
                </Rb.Form.Label>

                <Rb.InputGroup>
                  <Rb.Form.Control
                    ref={degRef}
                    dir={dirInput[selectedLng]}
                    value={degMap[selectedLng] ?? ""}
                    placeholder={mapTranslate["placeholderTheme"][selectedLng]}
                    autoComplete="off"
                    onKeyDown={(c) => {
                      if (selectedLng.indexOf("ar_AE") !== -1) {
                        //console.log(c.key);
                        if (c.key === "Backspace") {
                          const value = String(degMap[selectedLng]).slice(
                            0,
                            -1
                          );
                          setDegMap({ ...degMap, [selectedLng]: value });
                        }
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      setDegMap({ ...degMap, [selectedLng]: value });
                    }}
                    onBlur={() => {
                      if (selectedLng.indexOf("en_US") !== -1) {
                        setDegMap({
                          ...degMap,
                          ["en_US"]: degMap[selectedLng],
                        });
                      } else if (selectedLng.indexOf("ar_AE") !== -1) {
                        setDegMap({
                          ...degMap,
                          ["ar_AE"]: degMap[selectedLng],
                        });
                      } else {
                        setDegMap({
                          ...degMap,
                          ["en_US"]:
                            degMap["en_US"] == null || degMap["en_US"] == ""
                              ? degMap[selectedLng]
                              : degMap["en_US"],
                          ["ar_AE"]:
                            degMap["ar_AE"] == null || degMap["ar_AE"] == ""
                              ? degMap[selectedLng]
                              : degMap["ar_AE"],
                          ["fr_FR"]:
                            degMap["fr_FR"] == null || degMap["fr_FR"] == ""
                              ? degMap[selectedLng]
                              : degMap["fr_FR"],
                        });
                      }
                    }}
                    required
                    className="modal-form"
                    type="text"
                  />
                  {/* {selectedLng.indexOf("ar_AE") !== -1 && (
                    <Rb.InputGroup.Text
                      onClick={() => {
                        setShowArabicInput(true);
                      }}
                      className="cursor-pointer"
                      title="Ouvrir le clavier"
                      id="basic-addon1"
                    >
                      <i className="fa fa-keyboard"></i>
                    </Rb.InputGroup.Text>
                  )} */}
                </Rb.InputGroup>
              </Rb.Form.Group>
            </Rb.Col>
          )}

          {selectedLng && (
            <Rb.Col xs={6}>
              <Rb.Form.Group className="form-group" controlId="titre">
                <Rb.Form.Label
                  style={{
                    display: "flex",
                    flexDirection:
                      mapClassNameToLangue["flexDirection"][selectedLng],
                  }}
                  className={
                    "textClassInit column-gap-10 " +
                    mapClassNameToLangue["float"][selectedLng]
                  }
                >
                  {mapTranslate["ordreTheme"][selectedLng]}
                  <span className="text-danger">*</span>
                </Rb.Form.Label>

                <Rb.InputGroup>
                  <Rb.Form.Control
                    placeholder={mapTranslate["ordreplaceholder"][selectedLng]}
                    autoComplete="off"
                    value={typeof ordreMap !== "object" ? ordreMap : ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      setOrdre(value);
                    }}
                    required
                    className="modal-form"
                    type="text"
                  />
                  {/* {selectedLng.indexOf("ar_AE") !== -1 && (
                    <Rb.InputGroup.Text
                      onClick={() => {
                        setShowArabicInput(true);
                      }}
                      className="cursor-pointer"
                      title="Ouvrir le clavier"
                      id="basic-addon1"
                    >
                      <i className="fa fa-keyboard"></i>
                    </Rb.InputGroup.Text>
                  )} */}
                </Rb.InputGroup>
              </Rb.Form.Group>
            </Rb.Col>
          )}

          {selectedLng && (
            <Rb.Col xs={12}>
              <Rb.Form.Group className="form-group" controlId="description">
                <Rb.Form.Label
                  style={{
                    display: "flex",
                    flexDirection:
                      mapClassNameToLangue["flexDirection"][selectedLng],
                  }}
                  className={
                    "textClassInit column-gap-10 " +
                    mapClassNameToLangue["float"][selectedLng]
                  }
                >
                  {mapTranslate["description"][selectedLng]}
                </Rb.Form.Label>
                <Rb.InputGroup>
                  <Rb.Form.Control
                    ref={descriptionRef}
                    as="textarea"
                    rows={3}
                    dir={dirInput[selectedLng]}
                    value={descMap[selectedLng] ?? ""}
                    placeholder={mapTranslate["description"][selectedLng]}
                    autoComplete="off"
                    onChange={(e) => {
                      const value = e.target.value;
                      setDescMap({ ...descMap, [selectedLng]: value });
                      //   if (selectedLng.indexOf("ar_AE") === -1) {
                      //     setDescMap({ ...descMap, [selectedLng]: value });
                      //   }
                    }}
                    onBlur={() => {
                      if (selectedLng.indexOf("en_US") !== -1) {
                        setDescMap({
                          ...descMap,
                          ["en_US"]: descMap[selectedLng],
                        });
                      } else if (selectedLng.indexOf("ar_AE") !== -1) {
                        setDescMap({
                          ...descMap,
                          ["ar_AE"]: descMap[selectedLng],
                        });
                      } else {
                        setDescMap({
                          ...descMap,
                          ["en_US"]:
                            descMap["en_US"] == null || descMap["en_US"] == ""
                              ? descMap[selectedLng]
                              : descMap["en_US"],
                          ["ar_AE"]:
                            descMap["ar_AE"] == null || descMap["ar_AE"] == ""
                              ? descMap[selectedLng]
                              : descMap["ar_AE"],
                          ["fr_FR"]:
                            descMap["fr_FR"] == null || descMap["fr_FR"] == ""
                              ? descMap[selectedLng]
                              : descMap["fr_FR"],
                        });
                      }
                    }}
                    className="modal-form"
                    type="text"
                  />
                  {/* {selectedLng.indexOf("ar_AE") !== -1 && (
                    <Rb.InputGroup.Text
                      onClick={() => {
                        setShowArabicInput1(true);
                      }}
                      className="cursor-pointer"
                      title="Ouvrir le clavier"
                      id="basic-addon1"
                    >
                      <i className="fa fa-keyboard"></i>
                    </Rb.InputGroup.Text>
                  )} */}
                </Rb.InputGroup>
              </Rb.Form.Group>
            </Rb.Col>
          )}

          {selectedLng && (
            <Rb.Col xs={12}>
              <Rb.Form.Group className="form-group" controlId="motclei">
                <Rb.Form.Label
                  style={{
                    display: "flex",
                    flexDirection:
                      mapClassNameToLangue["flexDirection"][selectedLng],
                  }}
                  className={
                    "textClassInit column-gap-10 " +
                    mapClassNameToLangue["float"][selectedLng]
                  }
                >
                  {mapTranslate["keywordLabel"][selectedLng]}
                </Rb.Form.Label>
                <Rb.InputGroup>
                  <Rb.Form.Control
                    ref={descriptionRef}
                    as="textarea"
                    rows={3}
                    dir={dirInput[selectedLng]}
                    value={keywordMap[selectedLng] ?? ""}
                    placeholder={mapTranslate["keyword"][selectedLng]}
                    autoComplete="off"
                    onKeyDown={(key) => {
                      if (key.code === "Enter") {
                        key.preventDefault();
                        if (keywordMap[selectedLng]?.trim().length > 0) {
                          setKeywordMap({
                            ...keywordMap,
                            [selectedLng]: keywordMap[selectedLng] + " ; ",
                          });
                        }
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      console.log(value);

                      setKeywordMap({
                        ...keywordMap,
                        [selectedLng]: value,
                      });

                    }}
                    onBlur={() => {
                      if (selectedLng.indexOf("en_US") !== -1) {
                        setKeywordMap({
                          ...keywordMap,
                          ["en_US"]: keywordMap[selectedLng],
                        });
                      } else if (selectedLng.indexOf("ar_AE") !== -1) {
                        setKeywordMap({
                          ...keywordMap,
                          ["ar_AE"]: keywordMap[selectedLng],
                        });
                      } else {
                        setKeywordMap({
                          ...keywordMap,
                          ["en_US"]:
                            keywordMap["en_US"] == null ||
                            keywordMap["en_US"] == ""
                              ? keywordMap[selectedLng]
                              : keywordMap["en_US"],
                          ["ar_AE"]:
                            keywordMap["ar_AE"] == null ||
                            keywordMap["ar_AE"] == ""
                              ? keywordMap[selectedLng]
                              : keywordMap["ar_AE"],
                          ["fr_FR"]:
                            keywordMap["fr_FR"] == null ||
                            keywordMap["fr_FR"] == ""
                              ? keywordMap[selectedLng]
                              : keywordMap["fr_FR"],
                        });
                      }
                    }}
                    className="modal-form"
                    type="text"
                  />
                  {/* {selectedLng.indexOf("ar_AE") !== -1 && (
                    <Rb.InputGroup.Text
                      onClick={() => {
                        setShowArabicInput2(true);
                      }}
                      className="cursor-pointer"
                      title="Ouvrir le clavier"
                      id="basic-addon1"
                    >
                      <i className="fa fa-keyboard"></i>
                    </Rb.InputGroup.Text>
                  )} */}
                </Rb.InputGroup>
                {selectedLng.indexOf("ar_AE") === -1 &&
                  keywordMap[selectedLng]?.trim().length > 0 && (
                    <Rb.Form.Control.Feedback
                      className="d-flex fsize-10 text-success"
                      type="invalid"
                    >
                      {mapTranslate["semiColons"][selectedLng]}
                    </Rb.Form.Control.Feedback>
                  )}
              </Rb.Form.Group>
            </Rb.Col>
          )}
        </Rb.Row>

        <div className="float-right r-flexed column-gap-20 mb-20 mt-20">
          <Rb.Button
            onClick={() => {
              let msg =
                "Si vous fermez le modal, vous perderez les données déjà enregistrées !!!";
              CustomAlert({
                message: msg,
                yesBtn: () => {
                  dispatch(closeModalAdd());
                },
              });
            }}
            bsPrefix="btn btn-cancel"
          >
            Annuler
          </Rb.Button>
          <Rb.Button type="submit" bsPrefix="btn btn-save">
            Enregistrer
          </Rb.Button>
        </div>
      </Rb.Form>

      {selectedLng?.indexOf("ar_AE") !== -1 && (
        <ArabicInput
          value={selectedLng?.indexOf("ar_AE") !== -1 ? degMap["ar_AE"] : ""}
          onChange={(v) => {
            setDegMap({ ...degMap, [selectedLng]: v });
          }}
          show={showArabicInput}
          handleClose={closeKeyBoardArabic}
        />
      )}

      {selectedLng?.indexOf("ar_AE") !== -1 && (
        <ArabicInput
          value={selectedLng?.indexOf("ar_AE") !== -1 ? descMap["ar_AE"] : ""}
          onChange={(v) => {
            setDescMap({ ...descMap, [selectedLng]: v });
          }}
          show={showArabicInput1}
          handleClose={closeKeyBoardArabic1}
        />
      )}

      {selectedLng?.indexOf("ar_AE") !== -1 && (
        <ArabicInput
          title={"Les mots clés en arabe"}
          value={
            selectedLng?.indexOf("ar_AE") !== -1 ? keywordMap["ar_AE"] : ""
          }
          onChange={(v) => {
            setKeywordMap({ ...keywordMap, [selectedLng]: v });
          }}
          show={showArabicInput2}
          isForKeyword={true}
          handleClose={closeKeyBoardArabic2}
        />
      )}
    </div>
  );
};
